import HttpService from "../../../constant/Api";
import { message } from "antd";

const API = "/v1/packages";

export const getPackagesService = (sessionID) => {
  if (!sessionID) {
    message.error("Session ID not found");
  }
  return HttpService.get(`${API}/${sessionID}`);
};

export const buyPackageService = (data) => {
  return HttpService.post(`${API}/buy`, data);
};
